"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var auth0 = __importStar(require("auth0-js"));

var R = __importStar(require("ramda"));

var utils_1 = require("@8base/utils");

var jwt_decode_1 = __importDefault(require("jwt-decode"));

var isEmptyOrNil = R.either(R.isNil, R.isEmpty);
var isEmailVerified = R.pipe(R.pathOr(undefined, ['idTokenPayload', 'email_verified']), R.equals(true));
var getEmail = R.path(['idTokenPayload', 'email']);
var getIdToken = R.path(['idToken']);
var getIdTokenPayload = R.propOr(undefined, 'idTokenPayload');
var getState = R.propOr(undefined, 'state');
/**
 * Creates instacne of the web auth0 auth client.
 */

var WebAuth0AuthClient =
/*#__PURE__*/
function () {
  function WebAuth0AuthClient(options) {
    var storageOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WebAuth0AuthClient);

    utils_1.throwIfMissingRequiredParameters(['domain', 'clientId', 'redirectUri'], utils_1.PACKAGES.WEB_AUTH0_AUTH_CLIENT, options);

    var logoutRedirectUri = options.logoutRedirectUri,
        clientId = options.clientId,
        restOptions = __rest(options, ["logoutRedirectUri", "clientId"]);

    this.storageAPI = new utils_1.StorageAPI(storageOptions.storage || window.localStorage, storageOptions.storageKey || 'auth', storageOptions.initialState);
    this.logoutHasCalled = false;
    this.logoutRedirectUri = logoutRedirectUri;
    this.auth0 = new auth0.WebAuth(Object.assign({
      clientID: clientId,
      responseType: 'token id_token',
      scope: 'openid email profile'
    }, restOptions));
  }

  _createClass(WebAuth0AuthClient, [{
    key: "setState",
    value: function setState(state) {
      this.storageAPI.setState(state);
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.storageAPI.getState();
    }
  }, {
    key: "getTokenInfo",
    value: function getTokenInfo() {
      var _this$storageAPI$getS = this.storageAPI.getState(),
          token = _this$storageAPI$getS.token;

      if (!token) {
        return undefined;
      }

      try {
        return jwt_decode_1.default(token || '') || undefined;
      } catch (err) {
        return undefined;
      }
    }
  }, {
    key: "purgeState",
    value: function purgeState() {
      this.storageAPI.purgeState();
    }
  }, {
    key: "checkIsEmailVerified",
    value: function checkIsEmailVerified() {
      var tokenResult = this.getTokenInfo();
      return tokenResult && tokenResult.email_verified;
    }
  }, {
    key: "checkIsAuthorized",
    value: function checkIsAuthorized() {
      var _this$getState = this.getState(),
          token = _this$getState.token;

      return R.not(isEmptyOrNil(token));
    }
  }, {
    key: "authorize",
    value: function authorize() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.logoutHasCalled) {
        // @ts-ignore
        this.auth0.authorize(Object.assign({}, options));
      }
    }
  }, {
    key: "checkSession",
    value: function checkSession() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Promise(function (resolve, reject) {
        _this.auth0.checkSession(options, function (error, result) {
          if (error) {
            reject(error || {});
            return;
          }

          var idToken = getIdToken(result) || '';
          var jwtResult = jwt_decode_1.default(idToken) || {};
          resolve({
            idToken: idToken,
            firstName: jwtResult.given_name,
            lastName: jwtResult.family_name,
            picture: jwtResult.picture,
            email: getEmail(result),
            idTokenPayload: getIdTokenPayload(result),
            isEmailVerified: isEmailVerified(result),
            state: getState(result)
          });
        });
      });
    }
  }, {
    key: "changePassword",
    value: function changePassword() {
      var _this2 = this;

      var _this$getState2 = this.getState(),
          _this$getState2$email = _this$getState2.email,
          email = _this$getState2$email === void 0 ? '' : _this$getState2$email;

      return new Promise(function (resolve, reject) {
        _this2.auth0.changePassword({
          connection: 'Username-Password-Authentication',
          email: email
        }, function (error) {
          if (error) {
            reject(error || {});
            return;
          }

          resolve({
            email: email
          });
        });
      });
    }
  }, {
    key: "getAuthorizedData",
    value: function getAuthorizedData() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.auth0.parseHash(function (error, authResult) {
          if (error) {
            reject(error);
            return;
          }

          var idToken = getIdToken(authResult) || '';
          var jwtResult = jwt_decode_1.default(idToken) || {};
          resolve({
            idToken: idToken,
            firstName: jwtResult.given_name,
            lastName: jwtResult.family_name,
            picture: jwtResult.picture,
            email: getEmail(authResult),
            idTokenPayload: getIdTokenPayload(authResult),
            isEmailVerified: isEmailVerified(authResult),
            state: getState(authResult)
          });
        });
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this4 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      window.addEventListener('unload', function () {
        _this4.purgeState();
      });
      this.logoutHasCalled = true;
      this.auth0.logout(Object.assign({
        returnTo: this.logoutRedirectUri
      }, options));
    }
  }]);

  return WebAuth0AuthClient;
}();

exports.WebAuth0AuthClient = WebAuth0AuthClient;